module.exports = __webpack_public_path__ + "media/images/markers/youtube-2x-568c0ef03082f1488cdb1d65ec64be29.png";